import { nil, UITextView, UIView, YES } from "uicore-ts"
import { RHButton } from "../../Custom components/RH/RHButton"
import { RHFileUploadView } from "../../Custom components/RH/RHFileUploadView"
import { RHButtons, RHTables } from "../../Custom components/RH/Utils_slop/RHDesignTokens"

export class PartOfferDocumentsHeaderView extends UIView {

    readonly titleLabel = new UITextView().configuredWithObject({
        text: "Dokumendid",
        textAlignment: RHTables.headerTextAlignment,
        textColor: RHTables.headerTextColor,
        isSingleLine: YES,
        style: {
            fontFamily: RHTables.headerFontFamily,
            fontWeight: RHTables.headerFontWeight,
            fontSize: RHTables.headerFontSize,
            letterSpacing: RHTables.headerLetterSpacing
        }
    }).addedAsSubviewToView(this)

    readonly downloadButton = new RHButton().configuredWithObject({
        titleLabel: { text: RHFileUploadView.zipFolderIcon() },
        variant: RHButtons.compactPrimaryVariant,
        contentPadding: 0,
        style: { padding: "0px" },
        hoverText: "Lae alla kõik failid"
    }).addedAsSubviewToView(this)

    constructor(elementID?: string) {
        super(elementID)
        this.downloadButton.viewHTMLElement.setAttribute("aria-label", "Lae alla kõik failid")
    }

    override layoutSubviews() {
        super.layoutSubviews()
        const bounds = this.contentBounds
        const buttonSize = RHButtons.tableActionHeight

        bounds.rectangleWithHeight(buttonSize, 0.5)
            .distributeViewsAlongWidth(
                [this.titleLabel, this.downloadButton], undefined, this.core.paddingLength * 0.25, [nil, buttonSize]
            )
    }
}
